import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { SxProps } from 'src/components/muiTheme/utils';
import { Theme } from 'src/components/muiTheme/utils';
import { Service } from 'src/models/service/_types';
import { fetchServices } from 'src/models/service/service';

import { BaseSelect, SelectProps, createFormSelect } from './BaseSelect';

type ServiceSelectProps = Omit<SelectProps, 'options' | 'loading'> & {
  sx?: SxProps<Theme>;
};

export const ServiceSelect: FC<ServiceSelectProps> = (props) => {
  const { data: services = [], isLoading } = useQuery<Service[]>({
    queryKey: ['services', 'options'],
    queryFn: () => fetchServices({ includePrivate: true }),
    staleTime: 60000,
    gcTime: 60000,
  });

  const options = services
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((service) => ({
      id: service.id,
      label: service.name,
    }));

  return <BaseSelect {...props} options={options} loading={isLoading} />;
};

export const FormServiceSelect = createFormSelect(ServiceSelect);
